import { render, staticRenderFns } from "./editGoods.vue?vue&type=template&id=a36a42cc&scoped=true"
import script from "./editGoods.vue?vue&type=script&lang=js"
export * from "./editGoods.vue?vue&type=script&lang=js"
import style0 from "./editGoods.vue?vue&type=style&index=0&id=a36a42cc&prod&scoped=true&lang=css"
import style1 from "./editGoods.vue?vue&type=style&index=1&id=a36a42cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36a42cc",
  null
  
)

export default component.exports